import React from 'react';

function ThankYouFollowupsSkeleton({ count = 6 }) {
    return (
        <div className="table-responsive thank-you-surveys-table-wrap">
            <table className="table align-middle mb-0 thank-you-surveys-table thank-you-surveys-skeleton-table">
                <thead>
                    <tr>
                        <th className="thank-you-surveys-select-col ps-3"></th>
                        <th>Patient</th>
                        <th>Email</th>
                        <th>Cell Phone</th>
                        <th>Home Phone</th>
                        <th>Appointment</th>
                        <th>Email</th>
                        <th>SMS</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: count }).map((_, index) => (
                        <tr key={`thank-you-surveys-skeleton-${index}`}>
                            <td className="ps-3"><div className="thank-you-surveys-skeleton__box" /></td>
                            <td><div className="thank-you-surveys-skeleton__line thank-you-surveys-skeleton__line--medium" /></td>
                            <td><div className="thank-you-surveys-skeleton__line thank-you-surveys-skeleton__line--long" /></td>
                            <td><div className="thank-you-surveys-skeleton__line thank-you-surveys-skeleton__line--short" /></td>
                            <td><div className="thank-you-surveys-skeleton__line thank-you-surveys-skeleton__line--short" /></td>
                            <td><div className="thank-you-surveys-skeleton__line thank-you-surveys-skeleton__line--medium" /></td>
                            <td><div className="thank-you-surveys-skeleton__box" /></td>
                            <td><div className="thank-you-surveys-skeleton__box" /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ThankYouFollowupsSkeleton;
